import React from 'react';
import { Box, Button } from '@mui/material';

interface TabsProps {
    tabs: string[];
    activeTab: string;
    onTabChange: (tab: string) => void;
    tabsWithData?: string[];
    viewedTabs?: string[]; 
}

const Tabs: React.FC<TabsProps> = ({ 
    tabs, 
    activeTab, 
    onTabChange,
    tabsWithData = [],
    viewedTabs = []
}) => {
    return (
        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
            {tabs.map((tab) => {
                const hasData = tabsWithData.includes(tab);
                const isActive = activeTab === tab;
                const isViewed = viewedTabs.includes(tab);
                const shouldBlink = hasData && !isActive && !isViewed && tabsWithData.length > 1;

                return (
                    <Box key={tab} sx={{ position: 'relative' }}>
                        <Button
                            variant="contained"
                            onClick={() => onTabChange(tab)}
                            sx={{
                                background: activeTab === tab
                                    ? 'linear-gradient(45deg, black, #ed1b1b)'
                                    : '#e0e0e0',
                                color: activeTab === tab ? '#fff' : '#000',
                                textTransform: 'none',
                                fontSize: '0.85rem',
                                padding: '6px 16px',
                                minWidth: 'auto',
                                fontWeight: activeTab === tab ? 'bold' : 'normal',
                                borderRadius: '20px',
                                boxShadow: activeTab === tab ? 2 : 0,
                                '&:hover': {
                                    background: activeTab === tab
                                        ? 'linear-gradient(45deg, black, #ed1b1b)'
                                        : '#d5d5d5',
                                },
                            }}
                        >
                            {tab}
                        </Button>
                        {shouldBlink && (
                            <Box
                                sx={{
                                    position: 'absolute',
                                    top: '4px',
                                    right: '4px',
                                    width: '8px',
                                    height: '8px',
                                    borderRadius: '50%',
                                    backgroundColor: '#ed1b1b',
                                    animation: 'blink 1s infinite',
                                    '@keyframes blink': {
                                        '0%, 50%': { opacity: 1 },
                                        '51%, 100%': { opacity: 0.3 },
                                    },
                                }}
                            />
                        )}
                    </Box>
                );
            })}
        </Box>
    );
};

export default Tabs;